<template>
  <div>
    <el-dialog

        :visible.sync="dialogVisible"
        width="30%"
        style="margin-top: 3%"
    >
      <div class="boxItem1" v-if="certificate.certId">
        <img class="zsIcon" src="http://verification-t.bjzjtp.com/static/index/img/common_icon_succeed.png" alt="">
        <!-- <img class="zsIcon" src="http://verification-t.bjzjtp.com/static/index/img/common_icon_false.png" alt=""> -->
        <p>证书编号：<span style="">{{ certificate.certId }}</span></p>
        <p>证据哈希：<span>{{ certificate.fileHash }}</span></p>
        <p>区块链地址：<span>{{ certificate.blockChainAddress }}</span></p>
        <p>保全时间：<span>{{ certificate.timeTs }}</span></p>
      </div>
      <div class="boxItem1" v-else>
        <img class="zsIcon" src="http://verification-t.bjzjtp.com/static/index/img/common_icon_false.png" alt="">
        <br/>
        <br/>
        <br/>
      </div>
    </el-dialog>
    <main style='background: #EEEEEE;height: 1600px;'>
      <img src="../../assets/images/banner_bg.jpg" alt="" class="topImg">
      <div class="centerBox">
        <div class="liucheng">
          <div class="lcfirst">
            <p class="title">鉴定文书核验</p>
            <div class="boxItems">
              <!-- <div class="boxItem">
                <p>证书类型：</p>
                <el-select v-model="value" placeholder="请选择问题类别">
                  <el-option v-for="item in options" :key="item.value" :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </div> -->
              <div class="boxItem">
                <p>证书编号：</p>
                <el-input v-model="certificateCode" placeholder="司法鉴定意见书编号/电子数据预鉴定编号/区块链地址/证据哈希" clearable>
                </el-input>
              </div>
              <p class="btn" @click="document" v-loading="loading">立即核验</p>
            </div>
          </div>
          <p class="title2">文书核验</p>
          <p class="title3">通过区块链技术促进司法的可信与公开，提高了科技化法治化水平，加深了司法可信度，鉴定过程中的原始记录、数据处理、
            数据复核和证书签发等各环节的固化，保证数据的无法篡改性和安全性。</p>
          <div class="itemsBox">
            <div class="itemBox" v-for="item in itemBoxs">
              <img :src="item.img">
              <p>{{ item.name }}</p>
            </div>
          </div>
          <div class="imgbottom"></div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import navheader from '../../components/navheader.vue'
import footeritem from '../../components/footeritem.vue'
import axios from 'axios'
import '../../assets/css/index.less'
import '../../assets/css/fuWu.less';

export default {
  name: 'Pdf',
  components: {
    navheader,
    footeritem
  },
  data() {
    return {
      loading: false,
      infors: '',
      dialogVisible: false,
      certificateCode: '',
      certificate: {
        certId: '',
        fileHash: '',
        blockChainAddress: '',
        timeTs: ''

      },
      value: '',
      itemBoxs: [{
        name: '法官查阅DCI 电子登记档案',
        img: require('../../assets/images/icon_dci.png')
      },
        {
          name: '司法电子证据云 保全证书验证',
          img: require('../../assets/images/icon_cloud.png')
        },
        // {
        // 	name: '中科院授时中心 可信时间验证',
        // 	img: require('../../assets/images/icon_time.png')
        // },
        {
          name: '司法鉴定固化 报告验证',
          img: require('../../assets/images/icon_identify.png')
        }
      ],
    };
  },
  methods: {
    // 司法鉴定人列表
    document() {
      this.loading = true
      var that = this
      if (that.certificateCode == '') {
        this.$message({
          message: '证书编号不能为空',
          type: 'warning'
        });
        this.loading = false
        return false;
      }
      var params = new URLSearchParams();
      axios.post('/system/check/document?certificate=' + this.certificateCode, {}, {headers: {'Content-Type': 'application/json;charset=UTF-8'}}).then(res => {
        this.loading = false
        if (res.data.code === 0) {
          this.dialogVisible = true
          this.certificate = JSON.parse(res.data.msg)[0]
        } else {
          this.certificate = {
            certId: '',
            hashCode: '',
            blockChainAddress: '',
            timeTs: ''
          }
          this.dialogVisible = true
        }

      }, err => {
      })
    }
  },
  created() {

  },
  mounted() {
    let that = this;
  },
};
</script>

<style lang="less" scoped="scoped">
.boxItem1 {
  width: 100%;
  padding: 0 40px;
  box-sizing: border-box;

  p {
    font-size: 14px;
    font-family: Microsoft YaHei, Microsoft YaHei-Semibold;
    font-weight: 600;
    color: #000000;
    margin-bottom: 10px;

    span {
      font-weight: 400;
      line-height: 25px;
    }
  }
}

.zsIcon {
  width: 170px;
  height: 190px;
  display: block;
  margin: 0 auto;
  margin-bottom: 15%;

}

.topImg {
  width: 100%;
  display: block;
}

.centerBox {
  width: 1134px;
  margin: 0 auto;
  overflow: hidden;
  box-sizing: border-box;
}

.titleTip {
  width: 100%;
  border-left: 4px solid #01458E;
  padding-left: 10px;
}

.liucheng {
  position: absolute;
  top: 300px;

  // background: #F8F8F8;
  // padding: 30px 0;
  .lcfirst {
    width: 1000px;
    // height: 700px;
    margin: 0 auto;
    box-shadow: 0px 0px 0px NaNpx rgba(4, 32, 89, 0.15);
    box-sizing: border-box;
    border-radius: 10px;
    background: #fff;
    overflow: hidden;

    .title {
      width: 100%;
      height: 67px;
      line-height: 67px;
      background: #0068d8;
      padding: 0 30px;
      box-sizing: border-box;
      font-size: 22px;
      font-family: Microsoft YaHei, Microsoft YaHei-Bold;
      font-weight: 700;
      text-align: left;
      color: #ffffff;
      letter-spacing: 1px;
    }

    .boxItems {
      width: 100%;
      padding: 50px 230px;
      box-sizing: border-box;
      overflow: hidden;

      .boxItem {
        width: 100%;
        margin-bottom: 15px;
        overflow: hidden;
        display: flex;
        align-items: center;

        p {
          width: calc(20% - 15px);
          font-size: 16px;
          text-align: right;
          font-family: Microsoft YaHei, Microsoft YaHei-Regular;
          font-weight: 400;
          color: #666666;
        }

        .el-select,
        .el-input,
        .el-textarea {
          width: 500px;
          margin-left: 15px;
        }
      }

      .btn {
        width: 200px;
        height: 61px;
        line-height: 61px;
        background: #0068d8;
        border-radius: 15px;
        box-shadow: 0px 0px 0px NaNpx rgba(4, 32, 89, 0.15);
        font-size: 18px;
        font-family: Microsoft YaHei, Microsoft YaHei-Bold;
        font-weight: 700;
        text-align: left;
        color: #ffffff;
        margin: 0 auto;
        margin-top: 30px;
        text-align: center;
        cursor: pointer;
      }
    }

  }

  .title2 {
    width: 1000px;
    margin: 65px auto;
    margin-bottom: 20px;
    text-align: center;
    font-size: 22px;
    font-family: Microsoft YaHei, Microsoft YaHei-Bold;
    font-weight: 700;
    color: #333333;
  }

  .title3 {
    width: 950px;
    font-size: 16px;
    font-family: PingFangRegular;
    font-weight: 400;
    color: #333333;
    text-indent: 30px;
    margin: 0 auto;
    line-height: 30px;
  }

  .itemsBox {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    overflow: hidden;
    align-items: center;
    justify-content: center;
    margin-top: 30px;
    margin-bottom: 80px;

    .itemBox {
      width: 275px;
      height: 237px;
      opacity: 1;
      background: #ffffff;
      border-radius: 15px;
      margin-right: 30px;

      img {
        display: flex;
        margin: 0 auto;
        margin-top: 30px;
        margin-bottom: 20px;
      }

      p {
        width: 140px;
        font-size: 18px;
        font-family: Microsoft YaHei, Microsoft YaHei-Regular;
        font-weight: 400;
        text-align: center;
        color: #0068d8;
        line-height: 30px;
        margin: 0 auto;
        letter-spacing: 1px;
      }

      &:last-of-type {
        margin-right: 0;
      }
    }
  }

  .imgbottom {
    width: 100%;
    height: 557px;
    background: #f2f4f8;
    background: url(../../assets/images/pic_report.png) no-repeat center;
    background-size: cover;
  }

  @media screen and (max-width: 1024px) {
    & > div {
      width: 90%;
    }
  }
}
</style>
